import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  AfterViewInit,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ProfileUpdateRequestImpl } from "shared/cubiq-model-multi-asset";
import { BfxUserSettingsService, BfxUserSettingsComponentState } from "./bfx-user-settings.service";
import {
  SystemConfigPromiseService,
  ProfilePromiseActionService,
  UserPromiseLookupService,
} from "shared/cubiq-services";
import {
  IBfxUserSettingsPageSubComponent,
  BfxUserSettingsValidityState,
} from "app/bfx-user-settings/bfx-user-settings-page.component";
import * as CubiqServices from "shared/cubiq-services";
import * as SettingsConst from "./model/bfx-settings-constants";
import { BfxUserSettingsComponent } from "app/bfx-user-settings/bfx-user-settings.component";
import { BfxNotificationSettingsComponent } from "app/bfx-user-settings/bfx-notification-settings.component";
import { trigger, state, animate, transition, style } from "@angular/animations";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Component({
  selector: "bfx-notification-settings-emailsms",
  templateUrl: "./html/bfx-notification-settings-emailsms.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BfxNotificationSettingsEmailSmsComponent
  implements IBfxUserSettingsPageSubComponent<BfxNotificationSettingsComponent>, OnDestroy
{
  public activeSubComponent: number = 0;
  public categoryComponent: BfxNotificationSettingsComponent = null;
  public parentComponent: BfxUserSettingsComponent = null;
  public tableHeight: number = 240;
  public panelHeight: number = 0;
  public panelPopUpBodyHeight: number = 0;
  public ready: boolean = false;
  public dataChanged: boolean = false;
  public soundsList: any = [];
  public menuScrollHeight: number = 150;

  public disableEmailNotificationToggle: boolean = false;
  public disableSmsNotificationToggle: boolean = false;

  //Email and Sms tab
  public emailAddress: string = "";
  private _isEmailAddressValid: boolean = true;
  public get isEmailAddressValid(): boolean {
    return this._isEmailAddressValid;
  }
  public set isEmailAddressValid(value: boolean) {
    this._isEmailAddressValid = value;
    this.checkToDisableEmailToggleNotificationButtons();
  }
  public emailAddressChecked: boolean = false;
  private _isEmailAddressEmpty: boolean = true;
  public get isEmailAddressEmpty(): boolean {
    return this._isEmailAddressEmpty;
  }
  public set isEmailAddressEmpty(value: boolean) {
    this._isEmailAddressEmpty = value;
    this.checkToDisableEmailToggleNotificationButtons();
  }
  public isEmailAddressFocused: boolean = false;
  public invalidEmailFormatMessage: string = "";

  public smsNumber: string = "";
  private _isSmsNumberValid: boolean = true;
  public get isSmsNumberValid(): boolean {
    return this._isSmsNumberValid;
  }
  public set isSmsNumberValid(value: boolean) {
    this._isSmsNumberValid = value;
    this.checkToDisableSmsToggleNotificationButtons();
  }
  public smsNumberChecked: boolean = false;
  private _isSmsNumberEmpty: boolean = true;
  public get isSmsNumberEmpty(): boolean {
    return this._isSmsNumberEmpty;
  }
  public set isSmsNumberEmpty(value: boolean) {
    this._isSmsNumberEmpty = value;
    this.checkToDisableSmsToggleNotificationButtons();
  }
  public isSmsNumberFocused: boolean = false;
  public invalidSmsFormatMessage: string = "";

  public sendEmailAnyOrderIFillFg: boolean = false;
  public sendEmailMyOrdEnteredFg: boolean = false;
  public sendEmailMyOrdModifiedFg: boolean = false;
  public sendEmailMyOrdExpiryFg: boolean = false;
  public sendEmailMyOrdFillFg: boolean = false;
  public sendEmailMyOrdCanceledFg: boolean = false;
  public sendSMSAnyOrderIFillFg: boolean = false;
  public sendSMSMyOrdEnteredFg: boolean = false;
  public sendSMSMyOrdExpiryFg: boolean = false;
  public sendSMSMyOrdFillFg: boolean = false;
  public sendSMSMyOrdModifiedFg: boolean = false;
  public sendSMSMyOrdCanceledFg: boolean = false;
  public myOrdersEntryNotifications: string = "";
  public myOrdersFillNotifications: string = "";
  public myOrdersExpiryNotifications: string = "";
  public myFilledFillNotifications: string = "";
  public myOrdersModifiedNotifications: string = "";
  public myOrdersCanceledNotifications: string = "";
  private _modifiable = false;

  public get modifiable() {
    return this._modifiable;
  }

  public set modifiable(value) {
    this._modifiable = value;
    this.checkToDisableEmailToggleNotificationButtons();
    this.checkToDisableSmsToggleNotificationButtons();
  }

  constructor(
    public userSettingsService: BfxUserSettingsService,
    public systemConfigService: SystemConfigPromiseService,
    public profileService: ProfilePromiseActionService,
    public userService: UserPromiseLookupService,
    public element: ElementRef,
    public translationService: TranslateService,
    public cd: ChangeDetectorRef,
  ) {
    this.systemConfigService.getAllRoles().then((roles) => {
      this.modifiable = roles.has(CubiqServices.Roles.ROLE_SETTINGS_EMAIL_SMS_UPDATE);
      cd.detectChanges();
    });
  }

  public onTabActivated(event: any): void {}

  public initialize(): void {
    let activeUser: CubiqServices.ActiveUser = this.parentComponent.activeUser;
    this.activeSubComponent = this.parentComponent.activeSubCategory;
    this.initializeEmailAndSms(activeUser);
  }

  ngOnDestroy() {}

  private initializeEmailAndSms(activeUser: CubiqServices.ActiveUser) {
    if (activeUser.emailAddress != null) {
      this.emailAddress = activeUser.emailAddress;
      this.isEmailAddressEmpty = false;
    }

    if (activeUser.smsNumber != null) {
      this.smsNumber = activeUser.smsNumber;
      this.isSmsNumberEmpty = false;
    }

    if (!(this.emailAddress.length > 0 && this.smsNumber.length > 0)) {
      this.disableSmsNotificationToggle = true;
      this.disableEmailNotificationToggle = true;
    }

    this.sendEmailAnyOrderIFillFg = activeUser.sendEmailAnyOrderIFillFg;
    this.sendEmailMyOrdEnteredFg = activeUser.sendEmailMyOrdEnteredFg;
    this.sendEmailMyOrdExpiryFg = activeUser.sendEmailMyOrdExpiryFg;
    this.sendEmailMyOrdFillFg = activeUser.sendEmailMyOrdFillFg;
    this.sendSMSMyOrdEnteredFg = activeUser.sendSMSMyOrdEnteredFg;
    this.sendSMSMyOrdExpiryFg = activeUser.sendSMSMyOrdExpiryFg;
    this.sendSMSMyOrdFillFg = activeUser.sendSMSMyOrdFillFg;
    this.sendSMSAnyOrderIFillFg = activeUser.sendSMSAnyOrderIFillFg;
    this.sendSMSMyOrdModifiedFg = activeUser.sendSMSMyOrdModifiedFg;
    this.sendEmailMyOrdModifiedFg = activeUser.sendEmailMyOrdModifiedFg;
    this.sendEmailMyOrdCanceledFg = activeUser.sendEmailMyOrdCanceledFg;
    this.sendSMSMyOrdCanceledFg = activeUser.sendSMSMyOrdCanceledFg;

    this.myOrdersEntryNotifications = this.translationService.instant(
      "entry.notification.my.orders",
    );
    this.myOrdersFillNotifications = this.translationService.instant("fill.notification.my.orders");
    this.myOrdersExpiryNotifications = this.translationService.instant(
      "expiry.notification.my.orders",
    );
    this.myFilledFillNotifications = this.translationService.instant(
      "fill.notification.my.orders.filled",
    );
    this.myOrdersModifiedNotifications = this.translationService.instant(
      "modify.notification.my.orders.modified",
    );
    this.myOrdersCanceledNotifications = this.translationService.instant(
      "modify.notification.my.orders.canceled",
    );
    this.invalidEmailFormatMessage = this.translationService.instant("email_format_invalid");
    this.invalidSmsFormatMessage = this.translationService.instant("sms_format_invalid");

    this.ready = true;
    this.cd.markForCheck();

    this.checkToDisableEmailToggleNotificationButtons();
    this.checkToDisableSmsToggleNotificationButtons();
  }

  public helperEmailAddress_validateEmailAddress(event: any): void {
    let emailList: Array<string> = [];
    this.dataChanged = true;
    this.emailAddress = event.query;
    if (this.emailAddress.indexOf(",") == -1 && this.emailAddress.indexOf(";") == -1)
      emailList[0] = this.emailAddress;
    else if (this.emailAddress.indexOf(",") > -1) emailList = this.emailAddress.split(",");
    else if (this.emailAddress.indexOf(";") > -1) emailList = this.emailAddress.split(";");

    this.isEmailAddressEmpty = !(this.emailAddress.length > 0);

    if (emailList.length > 0) {
      for (let i: number = 0; i < emailList.length; i++) {
        if (!emailList[i].match(SettingsConst.VALID_EMAIL)) {
          this.isEmailAddressValid = false;
          this.emailAddressChecked = true;
          this.parentComponent.validate(this.categoryComponent);
          this.checkToDisableEmailToggleNotificationButtons();
          this.cd.markForCheck();
          return;
        } else {
          this.isEmailAddressValid = true;
        }
      }
    }

    this.checkToDisableEmailToggleNotificationButtons();
    this.emailAddressChecked = true;
    this.cd.markForCheck();
    this.parentComponent.validate(this.categoryComponent);
  }

  public helperSmsNumber_validateSmsNumber(event: any): void {
    this.dataChanged = true;
    const smsNumber = (this.smsNumber = event.query);
    this.isSmsNumberEmpty = !(this.smsNumber.length > 0);
    this.isSmsNumberValid = smsNumber.match(SettingsConst.VALID_SMS_NUMBER);
    this.checkToDisableSmsToggleNotificationButtons();
    this.smsNumberChecked = true;
    this.parentComponent.validate(this.categoryComponent);
  }

  public validate(): Promise<BfxUserSettingsValidityState> {
    return new Promise<BfxUserSettingsValidityState>((resolve, reject) => {
      let state;

      if (this.isEmailAddressEmpty && this.isSmsNumberEmpty)
        state = BfxUserSettingsValidityState.VALID;
      else if (this.isEmailAddressValid && this.isSmsNumberValid)
        state = BfxUserSettingsValidityState.VALID;
      else if (
        (this.isEmailAddressEmpty && this.isSmsNumberValid) ||
        (this.isSmsNumberEmpty && this.isEmailAddressValid)
      )
        state = BfxUserSettingsValidityState.VALID;
      else state = BfxUserSettingsValidityState.INVALID;

      //logger.out.info(`${this.constructor.name}.validate() valid:BfxUserSettingsValidityState.${BfxUserSettingsValidityState[state]}`);

      resolve(state);
    });
  }

  public reset(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      let activeUser: CubiqServices.ActiveUser = this.parentComponent.activeUser;
      this.resetEmailAndSmsTab(activeUser).then(() => {
        // let bookId = activeUser.defaultPositionBookId;
        // let bookname = activeUser.defaultPositionBookName;
        this.cd.detectChanges();
        resolve();
      });
    });
  }

  private resetEmailAndSmsTab(activeUser: CubiqServices.ActiveUser): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      if (activeUser.emailAddress != null) {
        this.emailAddress = activeUser.emailAddress;
      } else {
        this.emailAddress = "";
      }
      if (activeUser.smsNumber != null) {
        this.smsNumber = activeUser.smsNumber;
      } else {
        this.smsNumber = "";
      }

      this.isSmsNumberValid = true;
      this.isEmailAddressValid = true;
      this.isSmsNumberEmpty = !(this.smsNumber.length > 0);
      this.isEmailAddressEmpty = !(this.emailAddress.length > 0);

      this.sendEmailAnyOrderIFillFg = activeUser.sendEmailAnyOrderIFillFg;
      this.sendEmailMyOrdEnteredFg = activeUser.sendEmailMyOrdEnteredFg;
      this.sendEmailMyOrdExpiryFg = activeUser.sendEmailMyOrdExpiryFg;
      this.sendEmailMyOrdFillFg = activeUser.sendEmailMyOrdFillFg;
      this.sendSMSAnyOrderIFillFg = activeUser.sendSMSAnyOrderIFillFg;
      this.sendSMSMyOrdEnteredFg = activeUser.sendSMSMyOrdEnteredFg;
      this.sendSMSMyOrdExpiryFg = activeUser.sendSMSMyOrdExpiryFg;
      this.sendSMSMyOrdFillFg = activeUser.sendSMSMyOrdFillFg;
      this.sendEmailMyOrdModifiedFg = activeUser.sendEmailMyOrdModifiedFg;
      this.sendEmailMyOrdCanceledFg = activeUser.sendEmailMyOrdCanceledFg;
      this.sendSMSMyOrdModifiedFg = activeUser.sendSMSMyOrdModifiedFg;
      this.sendSMSMyOrdCanceledFg = activeUser.sendSMSMyOrdCanceledFg;
      resolve();
    });
  }

  public save(request: ProfileUpdateRequestImpl): void {
    this.saveEmailAndSmsSettings(request);
  }

  private saveEmailAndSmsSettings(request: ProfileUpdateRequestImpl): void {
    if (this.emailAddress != null) {
      request.emailAddress = this.emailAddress;
    }

    if (this.smsNumber != null) {
      request.smsNumber = this.smsNumber;
    }

    this.checkToDisableSmsToggleNotificationButtons();
    this.checkToDisableEmailToggleNotificationButtons();

    if (this.isSmsNumberEmpty === true) {
      this.sendSMSAnyOrderIFillFg = false;
      this.sendSMSMyOrdEnteredFg = false;
      this.sendSMSMyOrdExpiryFg = false;
      this.sendSMSMyOrdFillFg = false;
      this.sendSMSMyOrdModifiedFg = false;
      this.sendSMSMyOrdCanceledFg = false;
    }

    if (this.isEmailAddressEmpty === true) {
      this.sendEmailAnyOrderIFillFg = false;
      this.sendEmailMyOrdEnteredFg = false;
      this.sendEmailMyOrdExpiryFg = false;
      this.sendEmailMyOrdFillFg = false;
      this.sendEmailMyOrdModifiedFg = false;
      this.sendEmailMyOrdCanceledFg = false;
    }

    request.sendEmailAnyOrderIFillFg = this.sendEmailAnyOrderIFillFg;
    request.sendEmailMyOrdEnteredFg = this.sendEmailMyOrdEnteredFg;
    request.sendEmailMyOrdExpiryFg = this.sendEmailMyOrdExpiryFg;
    request.sendEmailMyOrdFillFg = this.sendEmailMyOrdFillFg;
    request.sendSMSAnyOrderIFillFg = this.sendSMSAnyOrderIFillFg;
    request.sendSMSMyOrdEnteredFg = this.sendSMSMyOrdEnteredFg;
    request.sendSMSMyOrdExpiryFg = this.sendSMSMyOrdExpiryFg;
    request.sendSMSMyOrdFillFg = this.sendSMSMyOrdFillFg;
    request.sendEmailMyOrdModifyFg = this.sendEmailMyOrdModifiedFg;
    request.sendEmailMyOrdCancelFg = this.sendEmailMyOrdCanceledFg;
    request.sendSMSMyOrdModifyFg = this.sendSMSMyOrdModifiedFg;
    request.sendSMSMyOrdCancelFg = this.sendSMSMyOrdCanceledFg;

    this.checkToDisableSmsToggleNotificationButtons();
    this.checkToDisableEmailToggleNotificationButtons();
  }

  public postReset(): void {
    this.emailAddressChecked = false;
    this.smsNumberChecked = false;
    this.isSmsNumberValid = true;
    this.isEmailAddressValid = true;
    this.isEmailAddressEmpty = !(this.emailAddress.length > 0);
    this.isSmsNumberEmpty = !(this.smsNumber.length > 0);
    this.dataChanged = false;
    this.checkToDisableSmsToggleNotificationButtons();
    this.checkToDisableEmailToggleNotificationButtons();
  }

  public postSave(request: ProfileUpdateRequestImpl): void {
    let activeUser = this.parentComponent.activeUser;
    this.postSaveEmailAndSms(activeUser);
    this.dataChanged = false;
  }

  private postSaveEmailAndSms(activeUser): void {
    activeUser.smsNumber = this.smsNumber;
    activeUser.emailAddress = this.emailAddress;
    activeUser.sendEmailAnyOrderIFillFg = this.sendEmailAnyOrderIFillFg;
    activeUser.sendEmailMyOrdEnteredFg = this.sendEmailMyOrdEnteredFg;
    activeUser.sendEmailMyOrdExpiryFg = this.sendEmailMyOrdExpiryFg;
    activeUser.sendEmailMyOrdFillFg = this.sendEmailMyOrdFillFg;
    activeUser.sendSMSAnyOrderIFillFg = this.sendSMSAnyOrderIFillFg;
    activeUser.sendSMSMyOrdEnteredFg = this.sendSMSMyOrdEnteredFg;
    activeUser.sendSMSMyOrdExpiryFg = this.sendSMSMyOrdExpiryFg;
    activeUser.sendSMSMyOrdFillFg = this.sendSMSMyOrdFillFg;
    activeUser.sendEmailMyOrdModifiedFg = this.sendEmailMyOrdModifiedFg;
    activeUser.sendEmailMyOrdCanceledFg = this.sendEmailMyOrdCanceledFg;
    activeUser.sendSMSMyOrdModifiedFg = this.sendSMSMyOrdModifiedFg;
    activeUser.sendSMSMyOrdCanceledFg = this.sendSMSMyOrdCanceledFg;

    this.emailAddressChecked = false;
    this.smsNumberChecked = false;
    this.isEmailAddressEmpty = !(this.emailAddress.length > 0);
    this.isSmsNumberEmpty = !(this.smsNumber.length > 0);
    this.checkToDisableSmsToggleNotificationButtons();
    this.checkToDisableEmailToggleNotificationButtons();
  }

  public onComponentStateChanged(componentState: BfxUserSettingsComponentState): void {
    this.panelHeight = componentState.componentBounds.height - 80;
    this.panelPopUpBodyHeight = this.panelHeight - 30;
  }

  public pageDataChanged($event) {
    this.dataChanged = true;
    this.cd.markForCheck();
    this.parentComponent.validate(this.categoryComponent);
  }

  public hasDataChanged(): boolean {
    return this.dataChanged;
  }

  private checkToDisableSmsToggleNotificationButtons() {
    this.disableSmsNotificationToggle =
      this.isSmsNumberEmpty || !this.isSmsNumberValid || !this.modifiable;
  }

  private checkToDisableEmailToggleNotificationButtons() {
    this.disableEmailNotificationToggle =
      this.isEmailAddressEmpty || !this.isEmailAddressValid || !this.modifiable;
  }
}
